module.exports = __webpack_public_path__ + "static/img/jn.b327635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jn.png
// module id = Ae02
// module chunks = 0